import React from "react";
import Head from "next/head";
import { NextSeo } from "next-seo";
import { seoFunct } from "../../config/next-seo.config.js";
import { withRouter } from "next/router";
import HomeNav from "../Home/HomeNav.jsx";
import HomeFooter from "../Home/HomeFooter.jsx";
import HighlightCard from "../../revampComponents/HighlightCard.js";
import FeaturesCard from "../../revampComponents/FeaturesCard.js";
import Banner from "../../revampComponents/Banner.js";
import revampData from "../../data/revampData.json";
const AttendeeApp = () => {
  const AttendeeAppHighlight = revampData.data.listAttendeeAppHighlights.data;
  const AttendeeAppFeatures = revampData.data.listAttendeeAppFeatureCards.data;
  const reorderByOrderNo = data => {
    return data.sort((a, b) => parseInt(a.orderNo) - parseInt(b.orderNo));
  };
  const reorderedData = reorderByOrderNo(AttendeeAppFeatures);
  return <div className="font-figtree" data-sentry-component="AttendeeApp" data-sentry-source-file="AttendeeApp.jsx">
            <HomeNav data-sentry-element="HomeNav" data-sentry-source-file="AttendeeApp.jsx" />
            <HighlightCard data={AttendeeAppHighlight} data-sentry-element="HighlightCard" data-sentry-source-file="AttendeeApp.jsx" />
            <FeaturesCard featuresData={reorderedData} data-sentry-element="FeaturesCard" data-sentry-source-file="AttendeeApp.jsx" />
            <HomeFooter data-sentry-element="HomeFooter" data-sentry-source-file="AttendeeApp.jsx" />

            <style jsx>{`
				.main-container {
					width: 100%;
				}
			`}</style>
        </div>;
};
export default withRouter(AttendeeApp);